import { CommonActionKey } from "common";

enum CustomActionKey {
  LinkYourBank = "linkYourBank",
}

export const SharedActionKey = {
  ...CommonActionKey,
  ...CustomActionKey,
};
